import { render, staticRenderFns } from "./BirthdayForm.vue?vue&type=template&id=23eb0f9c"
import script from "./BirthdayForm.vue?vue&type=script&lang=js"
export * from "./BirthdayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports